"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const usercirclefilled = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-usercirclefilled` : '') + (description ? ` desc-usercirclefilled` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-usercirclefilled"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-usercirclefilled"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_12940_4581)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 0C18.617 0 24 5.383 24 12C24 15.674 22.345 19.094 19.457 21.391L19.442 21.407C19.399 21.45 19.355 21.476 19.33 21.491C17.211 23.132 14.677 24 12 24C9.323 24 6.789 23.132 4.668 21.49C4.654 21.482 4.62933 21.4678 4.60141 21.4461L4.542 21.391C1.655 19.094 0 15.674 0 12C0 5.383 5.383 0 12 0ZM12 1.5C6.21 1.5 1.5 6.21 1.5 12C1.5 15.023 2.794 17.875 5.062 19.874C6.977 18.184 9.428 17.257 12 17.257C14.573 17.257 17.023 18.184 18.938 19.873C21.206 17.873 22.5 15.022 22.5 11.999C22.5 6.21 17.79 1.5 12 1.5ZM12 3.75C15.308 3.75 18 6.442 18 9.75C18 13.058 15.308 15.75 12 15.75C8.692 15.75 6 13.058 6 9.75C6 6.442 8.692 3.75 12 3.75Z",
    fill: "black"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_12940_4581"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = usercirclefilled;